import { Helmet } from 'react-helmet-async';
import { Calendar, MapPin, ClipboardList } from 'lucide-react';
import { useEdicao } from '../hooks/useEdicao';
import { SiteNav } from '../components/home/SiteNav';
import { SiteFooter } from '../components/home/Sections2027b';
import { PreInscricaoForm } from '../components/PreInscricaoForm';

export default function PreInscricaoPage() {
  const { edicao, periodo, local } = useEdicao();
  const title = `Pré-inscrição – Encontro de Casais Kairós ${edicao.ano}`;

  return (
    <div className="min-h-screen bg-obsidian" data-testid="pre-inscricao-page">
      <Helmet
        title={title}
        link={[{ rel: 'canonical', href: 'https://kairosseminarios.com.br/pre-inscricao' }]}
        meta={[{ name: 'description', content: `Faça a pré-inscrição do casal para o Kairós ${edicao.ano} (${periodo}) e receba em primeira mão a abertura do primeiro lote.` }]}
      />
      <SiteNav />

      <section className="pt-28 pb-12 relative overflow-hidden">
        <div className="absolute top-0 left-1/3 w-[500px] h-[500px] bg-kairos-orange/10 rounded-full blur-[150px]" />
        <div className="container mx-auto px-4 relative z-10 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-kairos-orange/15 border border-kairos-orange/40 mb-6">
            <ClipboardList className="w-4 h-4 text-kairos-orange" />
            <span className="text-kairos-orange text-xs font-semibold tracking-[0.2em]">PRÉ-INSCRIÇÕES ABERTAS</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mb-4">Pré-inscrição <span className="text-kairos-orange">Kairós {edicao.ano}</span></h1>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto mb-6">Preencham os dados do casal e recebam em primeira mão a abertura do primeiro lote, valores e condições.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-200 text-sm" data-testid="pre-inscricao-data"><Calendar className="w-4 h-4 text-kairos-orange" />{periodo}</span>
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-200 text-sm" data-testid="pre-inscricao-local"><MapPin className="w-4 h-4 text-kairos-orange" />{local}</span>
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto rounded-2xl border border-white/10 bg-obsidian-100/80 backdrop-blur p-6 md:p-10">
            {edicao.pre_inscricoes_abertas ? (
              <PreInscricaoForm periodo={periodo} />
            ) : (
              <p className="text-center text-gray-300 py-10" data-testid="pre-inscricao-fechada">As pré-inscrições não estão abertas no momento. Acompanhe nossas redes para novidades.</p>
            )}
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
